import admission from './en/admission'
import cashier from './en/cashier'
import examinationResults from './en/examinationResult'
import bulkProcess from './en/bulk-process'
import result from './en/result'
import downloadResult from './en/downloadResult'
import mappingData from './en/mappingData'
import branch from './en/branch'
import analysis from './en/analysis'
import packageService from './en/package'
import admissionSupport from './en/admissionSupport'

const en = {
  showing: 'Showing',
  to: 'to',
  of: 'of',
  entries: 'entries',
  canceled: 'Canceled',
  log: 'Log',
  date: 'Date',
  pin: 'PIN',
  close: 'Close',
  sending: 'Sending',
  send: 'Send',
  name: 'Name',
  additionalPackage: 'Additional Package',
  printing: 'Printing',
  bulkPrintCoverLetter: 'Bulk Print Cover Letter',
  coverLetter: 'Cover Letter',
  format: 'Format',
  verified: 'Verified',
  history: 'History',
  freeText: {
    selectExaminationItem: 'Select Examination Item',
    examinationItem: 'Examination Item'
  },
  refresh: 'Refresh',
  deltaCek: 'Delta Cek',
  validate: 'Validate',
  incomplete: 'Incomplete',
  generate: 'Generate',
  finished: 'Finished',
  failed: 'Failed',
  unvalidate: 'Unvalidate',
  data: 'Data',
  dan: 'and',
  businessIntegration: 'Business Integration',
  Format: 'Format',
  deleted: 'Deleted',
  result: 'Result',
  button: {
    'upload-photo-admission': 'Upload Admission Photo',
    addSpecialTask: 'Add Special Task',
    cancelSubmitAll: 'Cancel Submit All',
    sync: 'Sync',
    notFinish: 'Not Finish',
    previewAll: 'Preview All',
    verifyAll: 'Verify All',
    setMain: 'Set Main',
    add: 'Add',
    refresh: 'Refresh',
    cancel: 'Cancel',
    save: 'Save',
    search: 'Search',
    reset: 'Reset',
    close: 'Close',
    back: 'Back',
    action: 'Action',
    confirm: 'Confirm',
    detail: 'Detail',
    delete: 'Delete',
    finish: 'Finish',
    export: 'Export',
    other: 'Other',
    copy: 'Copy',
    saveanyway: 'Save Anyway',
    confirmation: 'Confirmation',
    revision: 'Revision',
    next: 'Next',
    previous: 'Previous',
    create: 'Create',
    update: 'Update',
    setNewPassword: 'Set New Password'
  },
  label: {
    finishedAt: 'Finished At',
    finishedBy: 'Finished By',
    createdDate: 'Created Date',
    includePreviousExaminationResult: 'Include Previous Examination Result',
    includeGeneralFormat: 'Include General Format',
    updateLocation: 'Update Location',
    registrationProductNumber: 'Product Reg. No',
    clearSearch: 'Clear Search',
    printAttachmentColor: 'Print Attachment in Colour'
  },
  action: 'Action',
  confirm: 'Confirm',
  detail: 'Detail',
  delete: 'Delete',
  created_by: 'Created By',
  finish: 'Finish',
  export: 'Export',
  other: 'Other',
  submitTask: 'Submit Task',
  copy: 'Copy',
  saveanyway: 'Save Anyway',
  confirmation: 'Confirmation',
  showingTo: 'Showing {{start}} to {{end}} of {{total}} entries',
  revision: 'Revision',
  next: 'Next',
  previous: 'Previous',
  create: 'Create',
  created_at: 'Created At',
  createdDate: 'Created Date',
  update: 'Update',
  add: 'Add',
  edit: 'Edit',
  print: 'Print',
  pay: 'Pay',
  transaction: 'Transaction',
  note: 'Note',
  language: 'Language',
  year: 'Year',
  month: 'Month',
  day: 'Day',
  list: 'List',
  years: 'Years',
  selectCategory: 'Select Category',
  months: 'Months',
  days: 'Days',
  modal: {
    confirmCancel: 'Confirm Cancel',
    confirmDelete: 'Confirm Delete',
    printResultHistory: {
      title: 'Print Result Data History',
      button: 'Print Result History'
    },
    sendIntegration: {
      title: 'Send Integration',
      message: 'Are you sure want to send integration?'
    },
    bulkSendIntegration: {
      title: 'Bulk Send Integration',
      message: 'Are you sure want to send bulk integration?',
      totalSelectedPatients: 'Total Selected Patients',
      patient: 'Patient'
    },
    updateFormatOption: {
      title: 'Update Format ',
      message: 'Are you sure want to update format option?'
    },
    bulkUpdateFormatOption: {
      title: 'Bulk Update Format',
      message: 'Are you sure want to bulk update format option?',
      totalSelectedPatients: 'Total Selected Patients',
      patient: 'Patient'
    },
    printInvoice: {
      title: 'Print Invoice',
      button: 'Print Invoice'
    },
    previewExaminationResultAll: {
      title: 'Preview All Examination Result',
      message: 'Are you sure want to preview all examination result?',
      button: 'Preview'
    },
    previewExaminationResult: {
      title: 'Preview Examination Result',
      message: 'Are you sure want to preview examination result?',
      button: 'Preview'
    },
    previewExaminationResultSummary: {
      title: 'Preview Examination Result Resume',
      message: 'Are you sure want to preview examination result Resume?',
      button: 'Preview'
    },
    bulkPrintDocument: {
      title: 'Bulk Print Label (Document)',
      message: 'Are you sure want to print MCU label (document) for selected patient?'
    },
    bulkPrintBarcode: {
      title: 'Bulk Print Label (Barcode)',
      message: 'Are you sure want to print MCU label (barcode) for selected patient?'
    },
    branchAlias: {
      title: 'Set Branch Alias'
    },
    modalBulkUploadAdmission: {
      title: 'Upload Photo Admission',
      confirm: {
        title: 'Confirm Upload ',
        message: 'Are you sure want to upload listed admission photo?'
      },
      modalInfo: {
        title: 'Field Upload Info',
        message1: 'You can upload the allowed file types : .jpg, .jpeg, ,png, .bmp.',
        message2: 'You can upload the allowed size 5 MB for file type (.jpg, .jpeg, .png, .bmp)'
      },
      modalInfo2: {
        title: 'Field Upload Info',
        message1: 'You can upload the allowed file types : .jpg, .jpeg, .png, .bmp, .pdf.',
        message2: 'You can upload the allowed size 5 MB for file type (.jpg, .jpeg, .png, .bmp, .pdf)'
      }
    },
    sortDataExaminationResult: {
      title: 'Sort Data Examination Result',
      sortBy: 'Sort By',
      order: 'Order',
      selectSortBy: 'Select Sort By',
      selectOrder: 'Select Order',
      button: 'Sort'
    }
  },
  no: 'No',
  more: 'More',
  show: 'Show',
  indonesia: 'Indonesia',
  english: 'English',
  save: 'Save',
  advanceSearch: 'Advance Search',
  data: 'Data',
  edit: 'Edit',
  view: 'View',
  previous: 'Previous',
  next: 'Next',
  No: 'No',
  verify: 'Verify',
  process: 'Process',
  add: 'Add',
  search: 'Search',
  cancel: 'Cancel',
  status: 'Status',
  uuid: 'UUID',
  select: 'Select',
  billed: 'Billed',
  unbilled: 'Unbilled',
  history: 'History',
  paid: 'Paid',
  preview: 'Preview',
  validation: 'Valiadation',
  major: 'Major',
  male: 'Male',
  female: 'Female',
  minor: 'Minor',
  download: 'Download',
  unpaid: 'Unpaid',
  review: 'Review',
  unverify: 'Unverify',
  unreview: 'Unreview',
  submit: 'Submit',
  entries: 'entries',
  filterby: 'Filter by',
  exportDataField: 'Are you sure want to export {{field}}?',
  'C-suspend': 'Are you sure want to suspend {{field}}?',
  'C-unsuspend': 'Are you sure want to unsuspend {{field}}?',
  'set-referenced': 'Are you sure want to set selected item as referenced?',
  'unset-referenced': 'Are you sure want to unset selected item as referenced?',
  'bulk-finished': 'Are you sure want to selected patient as finished?',
  'bulk-not-finished': 'Are you sure want to selected patient as not finished?',
  'W-01': 'The {{field}} field is required',
  'W-02': 'The {{field}} field is required',
  'W-03': 'The {{field}} field must be a valid email address',
  'W-04': 'The {{field}} field must have at least {{size}} characters',
  'W-05': 'The {{field}} field must be less than {{size}}',
  'W-06': "The {{field}} field doesn't reach minimum image dimensions",
  'W-07': "The {{field}} field doesn't reach maximum image dimensions",
  'W-08':
    'Sorry, the password confirmation does not match. Please double-check your password.',
  'W-09':
    'The {{field}} field must be less than or equal to {{size}} characters',
  'W-10': 'The {{field}} resolution must be less than or equal to {{size}}',
  'W-11': 'The allowed file type for {{field}} {{types}}',
  'W-12': 'The {{field}} must be a valid numeral formatting',
  'P-06A': 'Are you sure want to delete this {{data}}?',
  'P-37':
    'Sorry, your profile setup has been deleted. Please contact Administrator to re-config your profile.',
  cashier: {
    title: 'Cashier'
  },
  ...admission,
  cashier,
  examinationResults,
  bulkProcess,
  project : 'Project',
  result,
  branch,
  mappingData,
  admissionSupport,
  analysis,
  packageService,
  downloadResult,
  VALIDATED: 'Validated',
  ONTIME: 'On Time',
  ONPROCESS: 'On Process',
  LATE: 'Late',
  HOUR: 'Hours',
  DAY: 'Days',
  invalidated: 'Invalidated',
  columns: {
    productRegNo: 'Product Reg. No',
    patientName: 'Patient Name',
    patientCategory: 'Patient Category',
    status: 'Status',
    remarks: 'Remarks'
  },
  laboratory: {
    modalConfirm: {
      validated: {
        title: 'Confirm Validated Lab',
        message: 'Are you sure want to validate selected examination items?',
        messageAttachment: 'Are you sure want to validate selected attachment?'
      },
      invalidated: {
        title: 'Confirm Invalidated Lab',
        message: 'Are you sure want to invalidated selected examination items?',
        messageAttachment:
          'Are you sure want to invalidated selected attachment?'
      },
      verify: {
        title: 'Confirm Verify Lab',
        message: 'Are you sure want to verify selected examination items?',
        messageAttachment: 'Are you sure want to verify selected attachment?'
      },
      unverify: {
        title: 'Confirm Unverify Lab',
        message: 'Are you sure want to unverify selected examination items?',
        messageAttachment: 'Are you sure want to unverify selected attachment?'
      }
    }
  },
  form: {
    businessIntegration: {
      name: 'Business Integration',
      placeholder: 'Select Business Integration',
      required: 'The field Business Integration is required'
    },
    branchAlias: {
      name: 'Branch Alias',
      placeholder: 'Select Branch Alias',
      required: 'The field Branch Alias is required'
    },
    format: {
      name: 'Format',
      placeholder: 'Select Format'
    },
    status: {
      name: 'Status',
      placeholder: 'Select Status'
    },
    productCategory: {
      name: 'Product Category',
      placeholder: 'Select Product Category'
    },
    branchTeam: {
      name: 'Team ID',
      placeholder: 'Select Branch Team ID'
    },
    actualLocation: {
      name: 'Actual Location',
      placeholder: 'Select Actual Location'
    },
    partner: {
      name: 'Partner',
      placeholder: 'Select Partner'
    },
    partnerBranch: {
      name: 'Partner Branch',
      placeholder: 'Select Partner Branch'
    },
    visitCategory: {
      name: 'Visit Category',
      placeholder: 'Select Visit Category'
    },
    visitType: {
      name: 'Visit Type',
      placeholder: 'Select Visit Type'
    },
    patientClassification: {
      name: 'Patient Classification',
      placeholder: 'Select Patient Classification'
    },
    delimiter: {
      name: 'Delimiter',
      placeholder: 'Select Delimiter'
    },
    dateFormat: {
      name: 'Date Format',
      placeholder: 'Select Date Format'
    },
    oldPassword: {
      name: 'Old Password',
      placeholder: 'Old Password'
    },
    newPassword: {
      name: 'New Password',
      placeholder: 'New Password'
    },
    confirmNewPassword: {
      name: 'Confirm New Password',
      placeholder: 'Confirm New Password'
    },
    updateLocation: {
      name: 'Update Location',
      placeholder: 'Select Update Location'
    },
    sendingStatus: {
      name: 'Sending Status',
      placeholder: 'Select Sending Status'
    },
    sendingVia: {
      name: 'Sending Via',
      placeholder: 'Select Sending Via'
    }
  },
  module: {
    transactionData: {
      modal: {
        syncData: {
          title: 'Sync Data Transaction'
        }
      }
    },
    exportDataValidation: {
      modal: {
        exportDataValidation: {
          title: 'Export Data Validation',
          titleDetail: 'Detail Export Data Validation'
        }
      }
    },
    generateDataAnalysis: {
      modal: {
        confirm: {
          title: 'Confirm Generate Analysis',
          message:
            'Are you sure want to generate data analysis all patients in selected project?'
        }
      }
    },
    generateDataAnalysisSelected: {
      modal: {
        confirm: {
          title: 'Confirm Generate Analysis',
          message:
            'Are you sure want to generate data analysis selected patients?'
        }
      }
    },
    deleteGenerateDataAnalysis: {
      modal: {
        confirm: {
          title: 'Confirm Delete Analysis',
          message:
            'Are you sure want to delete data analysis selected patients?'
        }
      }
    },
    slaResult: {
      modal: {
        exportSlaResult: {
          title: 'Export SLA Result'
        }
      }
    },
    processResendDataLis: {
      modal: {
        processResendDataLis: {
          titleDetail: 'Process Resend Order LIS'
        }
      }
    }
  }
}

export default en
